const lenis = new Lenis();

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const heroContent = document.querySelector(".hero-content");
  const hero = document.querySelector("#hero");
  gsap.to(heroContent, {
    scale: 3,
    opacity: 0,
    scrollTrigger: {
      trigger: hero,
      scrub: true,
      start: () => 100,
      end: "+=100%",
    },
  });

  // Animation for my name
  const myName = document.querySelector("[data-gsap-name]");
  new SplitType(myName, { types: "words, chars", tagName: "span" });
  gsap.from(myName.querySelectorAll(".char"), {
    opacity: 0,
    xPercent: -20,
    duration: 0.5,
    ease: "power1.out",
    stagger: {
      amount: 1,
      each: 0.1,
    },
  });

  // Animation of icons
  const icons = document.querySelectorAll(".network__link");

  gsap.from(icons, {
    opacity: 0,
    yPercent: 100,
    delay: 0.5,
    stagger: {
      amount: 1,
    },
  });

  // Animation of titles
  const titles = document.querySelectorAll(".page__title");
  titles.forEach((title) => {
    gsap.from(title, {
      yPercent: -200,
      opacity: 0,
      scrollTrigger: {
        trigger: title,
        start: "bottom 90%",
        end: () => `+=200`,
        scrub: true,
      },
    });
  });

  // Animation of qualities
  const qualityItems = document.querySelectorAll(".quality__item");
  qualityItems.forEach((qualityItem, idx) => {
    gsap.from(qualityItem, {
      opacity: 0,
      rotateZ: (idx % 2 === 0 ? -1 : 1) * 5 + "deg",
      scrollTrigger: {
        scrub: true,
        trigger: qualityItem,
        start: "bottom 90%",
        end: () => `+=200`,
      },
    });
  });

  // Animation of text (general)
  const text = document.querySelectorAll("[data-gsap-text]");
  text.forEach((t) => {
    new SplitType(t, { types: "words, chars", tagName: "span" });
  });

  text.forEach((t) => {
    gsap.from(t.querySelectorAll(".char"), {
      opacity: 0,
      yPercent: -200,
      scrollTrigger: {
        trigger: t,
        start: "bottom 90%",
        end: () => "+=200",
        scrub: true,
        stagger: {
          amount: 0.1,
        },
      },
    });
  });

  // Animation of scroller
  const scroller = document.querySelector("[data-gsap-scroller]");
  gsap.from(scroller, {
    opacity: 0,
    scrollTrigger: {
      trigger: scroller,
      start: "bottom 90%",
      end: () => "+=200",
      scrub: true,
    },
  });

  // Animation of journey items
  const journeyItems = document.querySelectorAll("[data-gsap-journey-item]");
  for (const item of journeyItems) {
    gsap.from(item, {
      opacity: 0,
      yPercent: -100,
      scrollTrigger: {
        scrub: true,
        trigger: item,
        start: "bottom 90%",
        end: () => "+=200",
      },
    });
  }

  // Animation of contact form
  const form = document.querySelector("#contact-form");
    gsap.from(form, {
      opacity: 0,
      yPercent: -100,
      scrollTrigger: {
        scrub: true,
        trigger: form,
        start: "bottom 90%",
        end: () => "+=200",
      },
    });
});
